export interface ToolboxState {
  visible: boolean;
  timeoutId: NodeJS.Timeout | null;
}

export const defaultToolboxState: ToolboxState = {
  visible: false,
  timeoutId: null
};
